// Free Gift Functionality on Cart Page
async function FreeGiftReMove() {
  const FreeShippingThreshold = parseFloat(window.themeVariables.settings.FreeShippingThreshold);
  const responseJson = await fetch('/cart.js').then(res => res.json());

  const TotalCartPrice = responseJson.total_price / 100.00;
  const FreeGiftItems = responseJson.items.filter(item => item.sku.toLowerCase().includes('_gift'));

  // Remove free gifts if the total cart price is below the threshold
  if (FreeGiftItems.length > 0 && TotalCartPrice < FreeShippingThreshold) {
    await Promise.all(FreeGiftItems.map(removeFreeGift));
  }
}

async function removeFreeGift(gift_product) {
  const giftProductId = gift_product.id;
  const updates = { [giftProductId]: 0 };

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    console.log('Free gift removed');
    return response.json(); // Return the promise instead of reloading
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

// Adjust Height of Product card Title and Description.
const allProductCards = document.querySelectorAll('.product-list product-card');
if (allProductCards.length > 0) {

    let maxTitleHeight = 0;
    let maxDescriptionHeight = 0;

    allProductCards.forEach(product_card => {
        const productCardInfo = product_card.querySelector('.product-card__info');
        const productTitle = productCardInfo?.querySelector('.product-card__title');
        const ProductDescription = productCardInfo?.querySelector('.product-card__description span');

        const titleHeight = productTitle ? productTitle.offsetHeight : 0;
        const descHeight = productTitle ? ProductDescription.offsetHeight : 0;

      console.log(descHeight)

        maxTitleHeight = Math.max(maxTitleHeight, titleHeight);
        maxDescriptionHeight = Math.max(maxDescriptionHeight, descHeight);
    });

    allProductCards.forEach(product_card => {
        const productCardInfo = product_card.querySelector('.product-card__info');
        const productTitle = productCardInfo?.querySelector('.product-card__title');
        const ProductDescription = productCardInfo?.querySelector('.product-card__description');

        if (productTitle) {
            productTitle.style.height = `${maxTitleHeight}px`; // Set to max height
            // productTitle.style.margin = `10px 0`; // Set to max height
        }
        if (ProductDescription) {
            ProductDescription.style.height = `${maxDescriptionHeight}px`; // Set to max height
        }
    });
}


document.addEventListener("DOMContentLoaded", () => {
    setTimeout(function() {
        //Accept all cookies
        const cookiesFirstBtns = document.querySelectorAll("[data-cookiefirst-action='accept']");
        if (cookiesFirstBtns.length) {
            cookiesFirstBtns[0].addEventListener("click", (event) => {
                gtag('event', 'screen_view', { 'app_name': 'Accept all cookies', 'screen_name': 'Home' });
            });
        }

        const cookiesSecondBtns = document.querySelectorAll("[data-cookiefirst-action='adjust']");
        if (cookiesSecondBtns.length) {
            cookiesSecondBtns[0].addEventListener("click", (event) => {
                gtag('event', 'screen_view', { 'app_name': 'Adjust cookies', 'screen_name': 'Home' });
            });
        }
    }, 2000);
});

// Truncate Product Card Description only for mobile version
// function truncateDescription(string){
//   `${string.substring(0, 25)}...`;
// }
// const productCardDescriptionEle = document.querySelectorAll('.product-card__description');
// if(productCardDescriptionEle.length > 0){
//   productCardDescriptionEle.forEach(productCard=>{    
//     const innerDescription = productCard?.querySelector('p')?.innerText;
//     if(window.innerWidth < 768){    
//       document.addEventListener('DOMContentLoaded', truncateDescription(`${innerDescription}`));
//       window.addEventListener('resize', truncateDescription(`${innerDescription}`));
//     }
//   })
// }

function truncateDescription(string) {
  return string.length > 28 ? `${string.substring(0, 28)}...` : string;
}

const productCardDescriptionEle = document.querySelectorAll('.product-card__description');
if (productCardDescriptionEle.length > 0) {
  productCardDescriptionEle.forEach(productCard => {
    const innerDescription = productCard?.querySelector('span')?.innerText;

    const updateDescription = () => {
      if (window.innerWidth < 768) {
        productCard.querySelector('span').innerText = truncateDescription(innerDescription);
      }
    };
    document.addEventListener('DOMContentLoaded', updateDescription);
    window.addEventListener('resize', updateDescription);
  });
}

function popupModel() {
 document.body.classList.add('custom-popup');
}
function popupModelClose() {
 document.body.classList.remove('custom-popup');
}






var swiper = new Swiper('.announcement-bar__slider', {
  slidesPerView: 'auto',
  centeredSlides: true,
  paginationClickable: true,
  loop: true,
  slideToClickedSlide: true,
  navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
  breakpoints: {
    // when window width is >= 320px
    768: {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 30,
      centeredSlides: true
    },
    1024: {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 30,
      centeredSlides: true
    },
    1441: {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 30,
      centeredSlides: false
    }
  }
});



